const generateGoogleRecaptchaSrc = ({ useRecaptchaNet, useEnterprise, }) => {
    const hostName = useRecaptchaNet ? 'recaptcha.net' : 'google.com';
    const script = useEnterprise ? 'enterprise.js' : 'api.js';
    return `https://www.${hostName}/recaptcha/${script}`;
};
const cleanGstaticRecaptchaScript = () => {
    const script = document.querySelector(`script[src^='https://www.gstatic.com/recaptcha/releases']`);
    if (script) {
        script.remove();
    }
};
export const isScriptInjected = (scriptId) => !!document.querySelector(`#${scriptId}`);
export const cleanGoogleRecaptcha = (scriptId) => {
    const nodeBadge = document.querySelector('.grecaptcha-badge');
    if (nodeBadge && nodeBadge.parentNode) {
        document.body.removeChild(nodeBadge.parentNode);
    }
    const script = document.querySelector(`#${scriptId}`);
    if (script) {
        script.remove();
    }
    cleanGstaticRecaptchaScript();
};
export const injectGoogleReCaptchaScript = ({ reCaptchaKey, language, onLoad, useRecaptchaNet, useEnterprise, scriptProps: { nonce = '', defer = false, async = false, id = '', appendTo = undefined, } = {}, }) => {
    const scriptId = id || 'google-recaptcha-v3';
    if (isScriptInjected(scriptId)) {
        onLoad();
        return;
    }
    const googleRecaptchaSrc = generateGoogleRecaptchaSrc({
        useEnterprise,
        useRecaptchaNet,
    });
    const js = document.createElement('script');
    js.id = scriptId;
    js.src = `${googleRecaptchaSrc}?render=${reCaptchaKey}${language ? `&hl=${language}` : ''}`;
    if (!!nonce) {
        js.nonce = nonce;
    }
    js.defer = !!defer;
    js.async = !!async;
    js.onload = onLoad;
    const elementToInjectScript = appendTo === 'body'
        ? document.body
        : document.getElementsByTagName('head')[0];
    elementToInjectScript.appendChild(js);
};
export const logWarningMessage = (message) => {
    const isDevelopmentMode = !!process.env && process.env.NODE_ENV !== 'production';
    if (isDevelopmentMode) {
        return;
    }
    console.warn(message);
};
